import React from 'react'
import {
  object, array, string,
} from 'prop-types'

import RecipientDetails from './RecipientDetails'
import Attachments from './Attachments/Attachments'
import AttachmentsEmpty from './Attachments/AttachmentsEmpty'

function Sidebar({
  recipient, attachments, type,
}) {
  return (
    <div className="conversation-sidebar__content">
      <div className="conversation-sidebar__area">
        <div className="conversations-sidebar__header">
          <span className="section__title">Recipient details</span>
        </div>
        <div className="conversation-sidebar__section card card--flat">
          <RecipientDetails recipient={recipient} />
        </div>
      </div>
      {type !== 'file_conversion_request' && (
      <div className="conversation-sidebar__area">
        <div className="conversation-sidebar__header">
          <span className="section__title">Attachments</span>
        </div>
        <div className="conversation-sidebar__section card card--flat">
          {attachments.length > 0
            ? <Attachments attachments={attachments} />
            : <AttachmentsEmpty />}
        </div>
      </div>
      )}
    </div>
  )
}

Sidebar.propTypes = {
  recipient: object.isRequired,
  attachments: array.isRequired,
  type: string.isRequired,
}

export default Sidebar
